import { IUserWorkoutSessionSummary } from 'fitbeat.models';
import { IWorkoutRepository } from '../../persistence';

export class WorkoutHistory {
    constructor(private workoutRepository: IWorkoutRepository) {
    }

    public getAllWorkoutsForUser = async (userId: string, now: Date): Promise<IUserWorkoutSessionSummary[]> => {
        const workouts = await this.workoutRepository.getWorkoutHistory(userId, now);
        return workouts;
    }

    public getLastWeekWorkoutsForUser = async (
        userId: string, from: Date, to: Date,
        ): Promise<IUserWorkoutSessionSummary[]> => {
        const workouts = await this.workoutRepository.getHistoryBetweenDates(userId, from, to);
        return workouts;
    }
}
